/**
 * config/games.js
 *
 * Single source of truth for all games.
 * Imported by: HomePage, Navbar, App.js
 *
 * To add a new game: add an entry here, then create the page component.
 */

export const GAMES = [
  {
    key:         "spells",
    path:        "/guess-spell",
    title:       "Guess the Spell",
    description: "Guess the spell by its icon",
    icon:        "✨",
    navLabel:    "Spell",
    available:   true,
  },
  {
    key:         "locations",
    path:        "/guess-location",
    title:       "Guess the Location",
    description: "Identify a location in Azeroth",
    icon:        "🗺️",
    navLabel:    "Location",
    available:   true,
  },
  {
    key:         "npcs",
    path:        "/guess-npc",
    title:       "Guess the Character",
    description: "Identify a character from Azeroth",
    icon:        "⚔️",
    navLabel:    "Character",
    available:   true,
  },
  {
    key:         "lore",
    path:        "/guess-lore",
    title:       "Answer Lore Question",
    description: "Answer a question about Warcraft lore",
    icon:        "📜",
    navLabel:    "Lore",
    available:   true,
  },
]